const doc = [({"embed_form":({"first_name":"Ime", "last_name":"Prezime"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;